// this file is used to import all of the images which are dynamically loaded by pivotviewer and other components
// webpack cannot find them if they are within string templates, returned as function result path and other such cases

import '../app/insa-pivot/lib/simile-timeline/timeline_js/images/copyright-vertical.png';
import '../app/insa-pivot/lib/simile-timeline/timeline_js/images/progress-running.gif';
import '../app/insa-pivot/lib/simile-timeline/timeline_js/images/dull-blue-circle.png';
import '../Images/timeline_js/images/dark-red-circle.png';
import '../Images/timeline_js/images/blue-circle.png'; 
import '../Images/icon.png';
import '../Images/loader.gif';
import '../Images/w_maximize.png';
import '../Images/loading.gif';
import '../Images/GraphView.png';
import '../Images/GraphHistoric.png';
import '../Images/GraphHistoricSelected.png';
import '../Images/GridView.png';
import '../Images/TableView.png';
import '../Images/TimeView.png';
import '../Images/Tablegridview.png'; 
import '../Images/w_performance.png'; 
import '../Images/GraphViewSelected.png'; 
import '../Images/GridViewSelected.png'; 
import '../Images/GraphViewSelected.png';
import '../Images/TableViewSelected.png';
import '../Images/w_performance.png'; 
import '../Images/TimeViewSelected.png'; 
import '../Images/goout.gif';
import '../Images/layout_black.png';
import '../Images/layout_white.png';
import '../Images/nodata.svg';


// WEBPACK FOOTER //
// ./app/images.ts